module.exports = __webpack_public_path__ + "static/media/tuscany_1600x1062.22935b0c.jpg";